module.exports = __webpack_public_path__ + "img/clock.c5c3d3e5.svg";